import { computed, watch, type ComputedRef } from 'vue'
import { useRoute } from 'vue-router'

// useEntranceGUIDParam は、ルーティングのパラメータから entranceGUID を取得するための composable
//
// 注意事項：
// 基本的にこの composable を使うのは避けてください
// ルーティングのパラメータから entranceGUID を取得するには useRoute から取得した params を参照してください
// この composable の使いどころは、ルーティングと対応していないコンポーネントにおいてパラメータから entranceGUID を取得する必要がある場合です
//
// 使い方：
// 引数 must: composable が呼びされるルーティングにおいてパラメータに entranceGUID が存在することが保証されるかどうか
//   ログアウト時にもマウントされるコンポーネントや、特定の Entrance に依存せず、パラメータに entranceGUID が存在しないルーティングでマウントされる場合は must を false にしてください
export function useEntranceGUIDParam<T extends boolean = boolean>(args: {
  must: T
}): {
  entranceGUID: T extends true
    ? ComputedRef<string>
    : ComputedRef<string | undefined>
} {
  const route = useRoute()

  const entranceGUID = computed(() => {
    const params = route.params as unknown as Record<string, string>

    if (params.entranceGUID) {
      return params.entranceGUID
    }

    return undefined
  })

  watch(
    entranceGUID,
    v => {
      if (v == undefined && args.must) {
        throw new Error('entranceGUID is required')
      }
    },
    { immediate: true }
  )

  return {
    entranceGUID: entranceGUID as T extends true
      ? ComputedRef<string>
      : ComputedRef<string | undefined>,
  }
}
